import { z } from 'zod';
import { c } from '../../contract';
import { GalateaWrapUpData } from '../../types/WrapUp';

export const wrapUpRouter = c.router(
  {
    getWrapUpData: {
      summary: 'Get user wrap-up data for a specific month',
      method: 'GET',
      path: '/',
      query: z.object({
        locale: z.string(),
        month: z.string(),
      }),
      responses: {
        200: z.object({
          wrap_up: GalateaWrapUpData,
        }),
        404: z.object({
          error: z.string(),
        }),
        500: z.object({
          error: z.string(),
        }),
      },
    },
  },
  { pathPrefix: '/wrap-up' },
);
